module.exports = __webpack_public_path__ + "assets/img/opera.05d21c85.svg";